import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Notetaker from './icon-notetaker.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Notetaker {...validProps} />;
}
SvgComponent.iconName = 'notetaker';

export const NotetakerIcon = svgIconWrapper(SvgComponent);
